<template>
  <div style="background-color: #f2f2f2;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      定位服务
    </div>
    <div style="padding: 20px;">
      <div>
        <el-row>

          <div style="float:left">
            <el-input placeholder="请输入姓名" v-model="name" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>
            <el-input placeholder="请输入手机号" v-model="phone" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>
            <el-input placeholder="请输入身份证号" v-model="idCard" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>
            <el-button type="primary" icon="el-icon-search"  :loading="loading"   @click="getElderly">搜索</el-button>
          </div>
        </el-row>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <div style="border-radius: 10px"  class="baiduMap" >
          <baidu-map
              class="map"
              :center="center"
              :zoom="zoom"
              @ready="handler"
              :scroll-wheel-zoom="true"
              :mapClick="false"
          >
            <bm-marker
                :position="{lng: center.lng, lat: center.lat }"
                :dragging="true"
                animation="BMAP_ANIMATION_BOUNCE">
            </bm-marker>
          </baidu-map>
          </div>
        </template>
      </div>

    </div>



  </div>
</template>

<script>



import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data() {
    return {
      loading:false,
      name:'',
      phone:'',
      idCard:'',
      center:{
        lng:0,
        lat:0
      },
      zoom:''

    }
  },
  components: {

  },

  created() {
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init(){

    },
    handler({BMap,map}){
      console.log(BMap,map)
      this.center.lng=116.404;
      this.center.lat=39.915;
      this.zoom=15
    },
    getElderly(){
      this.loading=true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Positioning/PositioningForElderly",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          phone:this.phone,
          idCard:this.idCard
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.loading=false;
              console.log(response.data.data)
              this.center.lng=response.data.data.Lon;
              this.center.lat=response.data.data.Lat;
            } else if (response.data.error === 1) {
              this.loading=false;
              this.$message.error(response.data.message)
            }else {
              this.loading=false;
              this.$message({type: 'info', message: '定位失败'});
            }
          }
      )



    },


  }
}
</script>

<style  lang="scss"  scoped>

.baiduMap{
  border:  2px solid gray ;
  width: 100%;
  height: 750px;
  overflow:hidden;

  .map{
    width: 100%;
    height: 800px;
  }


}

</style>
